import React, {useEffect, useMemo, useState} from 'react';
import Translate from "../../../../../../../components/Translate";
import StatisticCard from "../../../../../../../components-new/general/statistics/StatisticCard";
import StatFilterCard from "../../../../../../../components-new/general/statistics/StatFilterCard";
import config from "../../../../../../../config";
import BotPlatformRequestTable from "./BotPlatformRequestTable";
import ForwardIcon from "../../../../../../../assets/icons/ForwardIcon";
import Colors from "../../../../../../../utils/Colors";
import XIcon from "../../../../../../../assets/icons/XIcon";
import CheckIcon from "../../../../../../../assets/icons/CheckIcon";

const OperatorsRequestsStatistics = ({
                                         isFetchingNumbers,
                                         statNumbers,
                                         isFetchingCompanyInfo,
                                         openTrModal,
                                         companyInfoList = [],
                                         company,
                                         tariff,
                                         user
                                     }) => {

    const features = tariff ? tariff.features : [];

    const [forbiddenSelected, setForbiddenSelected] = useState([]);
    const [workingHoursSelected, setWorkingHoursSelected] = useState([]);
    const [blockedSelected, setBlockedSelected] = useState([]);

    useEffect(() => {
        const ids = companyInfoList.map(c => c.companyId);
        setForbiddenSelected(ids);
        setWorkingHoursSelected(ids);
        setBlockedSelected(ids);
    }, [companyInfoList]);

    const toggle = (setter, id) => {
        setter(prev =>
            prev.includes(id)
                ? prev.filter(x => x !== id)
                : [...prev, id]
        );
    };

    const forbiddenWordsCount = useMemo(() => {
        return companyInfoList.reduce((sum, c) => {
            if (!forbiddenSelected.includes(c.companyId)) return sum;
            return sum + (c.forbiddenWordsReplacedCount || 0);
        }, 0);
    }, [companyInfoList, forbiddenSelected]);

    const offWorkingHoursCount = useMemo(() => {
        return companyInfoList.reduce((sum, c) => {
            if (!workingHoursSelected.includes(c.companyId)) return sum;
            return sum + (c.offWorkingHoursAttemptCount || 0);
        }, 0);
    }, [companyInfoList, workingHoursSelected]);

    const blockedUsersCount = useMemo(() => {
        return companyInfoList.reduce((sum, c) => {
            if (!blockedSelected.includes(c.companyId)) return sum;
            return sum + (c.blockedUserAttemptCount || 0);
        }, 0);
    }, [companyInfoList, blockedSelected]);

    const filterItems = useMemo(
        () => companyInfoList.map(c => ({id: c.companyId, name: c.companyName})),
        [companyInfoList]
    );

    const counterCards = [
        <StatisticCard
            key="all"
            onClick={() => openTrModal('allRequestsToOperator')}
            title="all"
            value={statNumbers.allRequests}
            loading={isFetchingNumbers}
        />,
        <StatisticCard
            key="todays"
            onClick={() => openTrModal('todaysRequestsToOperator')}
            title="todays"
            value={statNumbers.todaysRequests}
            loading={isFetchingNumbers}
        />,
        <StatisticCard
            key="active"
            onClick={() => openTrModal('activeRequests', {statuses: [config.conversationStatuses.operatorProcessing]})}
            title="active"
            value={statNumbers.activeRequests}
            loading={isFetchingNumbers}
        />,
        <StatisticCard
            key="answered"
            onClick={() => openTrModal('answeredRequestsToOperator', {unanswered: false})}
            title="answered"
            value={statNumbers.answeredRequests}
            loading={isFetchingNumbers}
            icon={<CheckIcon style={{color: Colors.blueDark}} stroke="currentColor"/>}
        />,
        <StatisticCard
            key="unanswered"
            onClick={() => openTrModal('unansweredRequestsToOperator', {unanswered: true})}
            title="unanswered"
            value={statNumbers.unansweredRequests}
            loading={isFetchingNumbers}
            icon={<XIcon style={{color: Colors.blueDark}} stroke="currentColor"/>}
        />,
        features.includes(config.features.CONVERSATION_FORWARD) && (
            <StatisticCard
                key="forwarded"
                onClick={() => openTrModal('forwardedRequestsToOperator', {forwarded: true})}
                title="forwarded"
                value={statNumbers.forwardedRequests}
                loading={isFetchingNumbers}
                icon={<ForwardIcon style={{color: Colors.blueDark}} stroke="currentColor"/>}
            />
        ),
    ].filter(Boolean);

    const filterCards = [
        features.includes(config.features.FORBIDDEN_WORDS) && (
            <StatFilterCard
                key="forbidden"
                title="forbiddenWordsReplacedCount"
                items={filterItems}
                selectedIds={forbiddenSelected}
                onToggle={(id) => toggle(setForbiddenSelected, id)}
                onToggleAll={setForbiddenSelected}
                loading={isFetchingCompanyInfo}
                value={forbiddenWordsCount}
            />
        ),
        features.includes(config.features.WORKING_HOURS) && (
            <StatFilterCard
                key="workingHours"
                title="offWorkingHoursAttemptCount"
                items={filterItems}
                selectedIds={workingHoursSelected}
                onToggle={(id) => toggle(setWorkingHoursSelected, id)}
                onToggleAll={setWorkingHoursSelected}
                loading={isFetchingCompanyInfo}
                value={offWorkingHoursCount}
            />
        ),
        features.includes(config.features.BLACK_LIST) && (
            <StatFilterCard
                key="blocked"
                title="blockedUserAttemptCount"
                items={filterItems}
                selectedIds={blockedSelected}
                onToggle={(id) => toggle(setBlockedSelected, id)}
                onToggleAll={setBlockedSelected}
                loading={isFetchingCompanyInfo}
                value={blockedUsersCount}
            />
        ),
    ].filter(Boolean);

    return (
        <React.Fragment>
            <div className="stat-card-group stat-card-group--counters">
                {counterCards}
            </div>
            {filterCards.length > 0 && (
                <div className="stat-card-group stat-card-group--filters">
                    {filterCards}
                </div>
            )}

            {/*
                No --scroll here any more. The section holds date pickers and a
                dropdown, and their panels were being clipped by the scroll box -
                which is exactly what the rule's own comment warns against. The
                table inside brings its own scrolling.
            */}
            <div className="stat-section">
                <div className="stat-section__head">
                    <h2 className="stat-section__title"><Translate text="requestsByBotsAndPlatforms"/></h2>
                </div>
                {company && company.tariff && company.tariff.messengers && (
                    <BotPlatformRequestTable
                        company={company}
                        onCellClick={openTrModal}
                        user={user}
                    />
                )}
            </div>

        </React.Fragment>
    );
};

export default OperatorsRequestsStatistics;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/statistics/components/requestsToOperators/OperatorsRequestsStatistics.jsx